import React, { Component } from 'react';
import {connect} from 'react-redux';
import warningIcon from '../../../assets/warning.svg';



class OfficeHierarchyManagement extends Component {

  constructor(props) {
    super(props);
    this.state = {
        staticHierarchy: this.props.user.profile.organizationId.staticHierarchy,
        availableOffices:[
          {value:"Engineer", label:"Engineer"},
          {value:"New Office", label:"New Office"}
        ],
        officeLength:3
    }
  }

  changeName=(value)=>{
    console.log(value)
    this.setState({newName:value.label})
  }
  



  render() { 
    let {officeLength}=this.state
      console.log(this.state, this.props)
    let {manageNewOffices}=this.props.orgChart

    return ( 
      <div>
        <div className="mt30">
          <div className="title-text">
            Office Hierarchy Management
          </div>
        </div>
        <hr/>

        <div className="alert-msg-bg mt50">
          <i className="close-icon">close</i>
					<div className="d-flex custom-message-box">
						<i className="material-icons alert-icon-bg">remove_circle</i>
            <span className="ml10 alert-msg-text">
              
              <span className="newOfficesFoundTxt">
              The following {manageNewOffices.length} Office(s) names were not found:  
              </span>

              {manageNewOffices.map( (e, idx) =>{
                return(
                  <p className="newOfficesFoundContent" key={idx}> {e.label} </p>
                )
              })} 
            </span>
					</div>
				</div>


        <div className="officeOptionsContainer">
         <p className="officeOptionsItems">
         <img src={warningIcon} className="alert-i imgOfficeMngmt"/>
Please check if any office names have been changed. If so, click here

              <span className="float-right officeHierarchyContinueBtn btn btn-secondary" onClick={()=>this.props.history.push(`/home/enterprise-info/org-chart/management/edit`)}>
                {/* Update Office Name */}
                Update 
              </span>
            </p>
            <p className="officeOptionsItems">
            <img src={warningIcon} className="alert-i imgOfficeMngmt"/>
Please check if any new offices have been added to the organization. If so, click here
              
              <span className="float-right officeHierarchyContinueBtn btn btn-secondary">
              <a className="fontWhite" href="mailto:team@ouroffice.io">Contact Us</a>
              </span>
            </p>
            <p>
            <img src={warningIcon} className="alert-i imgOfficeMngmt"/>
 Please check accuracy of all the office names, and make edits as needed.
              <span className="float-right officeHierarchyContinueBtn btn btn-secondary" onClick={()=>this.props.history.push(`/home/upload-data`)}>
                Upload again
              </span>
            </p>
        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  console.log(state)
  return {
    user : state.user,
    orgChart:state.orgChart
  }
}
 
export default connect(mapStateToProps)(OfficeHierarchyManagement);